import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import {
  backGroundColorCode,
  foreColorCodeLite,
  foreColorCodePagination,
} from "../../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import useFetchDrafts from "../../../../hooks/useFetchDrafts";
const TextInputWithNoSearch = (props) => {
  const user = useRecoilValue(userState);

  return (
    <TextField
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      onChange={props.onChange}
      disabled={props.disabled}
      InputLabelProps={{ shrink: true }}
      //   InputProps={
      //     props.InputProps
      //       ? {
      //           startAdornment: (
      //             <InputAdornment position="start">
      //               <SearchIcon
      //                 style={{
      //                   color: foreColorCodePagination(user?.mode ?? "lite"),
      //                 }}
      //               />
      //             </InputAdornment>
      //           ),
      //         }
      //       : null
      //   }
      sx={{
        "&&&": {
          margin: "0px",
          color: foreColorCodePagination(user?.mode ?? "lite"),
          width: "140px",
          margin: "0 10px 0 0",
        },
        "& label": {
          color: foreColorCodePagination(user?.mode ?? "lite"),
        },
        "& svg": {
          backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
          color: foreColorCodePagination(user?.mode ?? "lite"),
        },
        "& input": {
          paddingLeft: "10px",
          fontSize: "14px",
          color: foreColorCodeLite(user?.mode ?? "lite"),
          height: "33px",
          backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
          borderRadius: "5px",
        },
      }}
    />
  );
};
export default TextInputWithNoSearch;
